<template>
  <v-app>
    <div v-if="loaded && isLoggedIn">
      <toolbar></toolbar>
      <router-view>
      </router-view>
      <Notification></Notification>
      <Prompt></Prompt>
      <Error></Error>
      <Linking></Linking>
    </div>
    <LoginModal @loaded="loaded=true"></LoginModal>
    <LoaderModal></LoaderModal>
  </v-app>
</template>

<script>
  import Toolbar from "./components/Toolbar";
  import LoaderModal from "./components/LoaderModal";
  import LoginModal from './components/LoginModal'
  import { mapGetters } from 'vuex'
  import Notification from './components/system/Notification'
  import Prompt from './components/system/Prompt'
  import Error from './components/system/Error'
  import Linking from '@/components/system/Linking'

  export default {
    name: 'App',
    data() {
      return {
        loaded: false
      }
    },
    components: { Linking, Error, Prompt, Notification, LoginModal, LoaderModal, Toolbar},
    computed: {
      ...mapGetters({
        isLoggedIn: 'user/isLoggedIn',
        user: 'user/userInfo'
      })
    },
    beforeMount() {
      let me = this;

      this.$store.dispatch('initApp')
        .then(() => {
            me.$root.$i18n.locale = this.user.locale
            me.loaded = true
        })
      .catch(() => {
      })
    }
  }
</script>
